import { toast as sonner } from 'vue-sonner'

type Data = Parameters<typeof sonner>[1]

// The app's toasts (the alerts redesign, GET-113). They look the same for every tone (App.vue's Toaster and
// style.css); only how long they stay differs: an error stays until closed, a warning or anything with an action
// (Undo) gets 8 s, the rest the Toaster's 5 s. Import this, never vue-sonner, so every call gets those timings.
const LONG = 8000

function message(text: string, data?: Data) {
  return data?.action ? sonner(text, { duration: LONG, ...data }) : data === undefined ? sonner(text) : sonner(text, data)
}

export const toast = Object.assign(message, {
  success: (text: string, data?: Data) => (data === undefined ? sonner.success(text) : sonner.success(text, data)),
  info: (text: string, data?: Data) => (data === undefined ? sonner.info(text) : sonner.info(text, data)),
  warning: (text: string, data?: Data) => sonner.warning(text, { duration: LONG, ...data }),
  error: (text: string, data?: Data) => sonner.error(text, { duration: Infinity, ...data }),
  dismiss: (id?: number | string) => sonner.dismiss(id),
})
